import { NgModule, APP_INITIALIZER, Optional, SkipSelf } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { FooterModule } from 'footer';
import { NavbarModule } from 'navbar';
import { UnauthorizedLandingModule } from 'unauthorized-landing';
import { TokenInterceptor, ErrorInterceptor, AuthGuardService, AuthService } from 'auth';
import { AppConfigService } from 'app-config';
import { APP_BASE_HREF } from '@angular/common';
import { environment } from 'src/environments/environment';
import { content } from 'src/assets/content';
import { CommonModule } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';

export function initConfig(config: AppConfigService) {
	return () => config.load();
}

@NgModule({
	declarations: [ ],
	imports: [
		FooterModule,
		NavbarModule,
		UnauthorizedLandingModule,
		CommonModule
	],
	exports: [
		FooterModule,
		NavbarModule,
		UnauthorizedLandingModule
	],
	providers: [
		AuthGuardService,
		AuthService,
		AppConfigService,
		CookieService,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: TokenInterceptor,
			multi: true
		}, {
			provide: HTTP_INTERCEPTORS,
			useClass: ErrorInterceptor,
			multi: true
		}, {
			provide: APP_INITIALIZER,
			useFactory: initConfig,
			deps: [AppConfigService],
			multi: true
		}, {
			provide: APP_BASE_HREF,
			useValue: window['base-href']
		}, {
			provide: 'environment',
			useValue: environment
		}, {
			provide: 'content',
			useValue: content
		}
	]
})
export class CoreModule {
	constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
		if (parentModule) {
			throw new Error('CoreModule has already been loaded. You should only import Core modules in the AppModule only.');
		}
	}
}